/**
 * ============================================================================
 * ToggleNodeView — NodeView React do bloco `toggle` (accordion GitBook-like).
 * Título (summary) editável inline; corpo renderiza via NodeViewContent.
 *
 * CHANGELOG:
 *   RELEASE: 2026-07-08 v1.0.0 - Versão inicial.
 * ============================================================================
 */
import { NodeViewWrapper, NodeViewContent, type NodeViewProps } from "@tiptap/react";
import { useState } from "react";

export function ToggleNodeView({ node, updateAttributes, editor }: NodeViewProps) {
  const [open, setOpen] = useState(true);
  const summary = String(node.attrs.summary ?? "Detalhes");
  const editable = editor?.isEditable ?? true;

  return (
    <NodeViewWrapper as="div" className="kb-toggle" data-open={open ? "true" : "false"}>
      <div className="kb-toggle-summary" contentEditable={false} onClick={() => setOpen((v) => !v)}>
        <span
          className="flex-1 outline-none"
          contentEditable={editable}
          suppressContentEditableWarning
          onClick={(e) => e.stopPropagation()}
          onBlur={(e) => updateAttributes({ summary: (e.target as HTMLElement).innerText.trim() || "Detalhes" })}
          data-placeholder="Título do accordion"
        >
          {summary}
        </span>
      </div>
      {open && (
        <div className="kb-toggle-body">
          <NodeViewContent />
        </div>
      )}
    </NodeViewWrapper>
  );
}
